import { Service } from '../Service'
import { makeFilter, equals } from '@/utils/dynamic'

const API = 'Contents'

const ENDPOINTS = {
  GET: `${API}/Get`,
  GET_DYNAMIC: `${API}/GetAllDynamic`,
  POST: `${API}/Create`,
  PATCH: `${API}/Patch`,
  PUT: `${API}/Put`,
  DELETE: `${API}/Delete`
}

export const CONTENT_KEYS = {
  EXCHANGE_AGREEMENT: 'exchange-agreement',
  INVOICE_3: 'invoice',
  INVOICE_4: 'invoice-proforma-shipping',
  INVOICE_5: 'invoice-proforma-payment',
  INVOICE_7: 'invoice-credit-note',
  INVOICE_8: 'invoice-rma',
  INVOICE_9: 'invoice-proforma-shipping',
  INVOICE_10: 'invoice-proforma-shipping',
  ORDER_ACKNOWLEDGMENT: 'po-acknowledgment',
  ATA_106: 'ata-106',
  PO: 'bax-po',
  PROFORMA_SHIP_SUPPLIER: 'ship-supplier',
  QUOTE_MULTI_PARTS: 'quote-multi-parts',
  TD_REPORT: 'td-report',
  WO: 'bax-po'
}

class ModuleService extends Service {
  async getByContentKey (key) {
    const result = await this.getAllDynamic({ take: 1, filter: makeFilter('contentKey', key, equals) })

    if (result.data.value.length !== 1) {
      throw new Error('content-not-found')
    }

    return { ...result, data: result.data.value[0] }
  }
}

export const ServiceContents = new ModuleService({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})
